var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute top-0 w-100 h-100 d-flex align-center justify-center",staticStyle:{"z-index":"5","background-color":"#f4f6f9"}},[_c('Icon',{attrs:{"icon":"svg-spinners:pulse-rings-3","color":"#ec9436","width":"100"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }